import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, getLocalStoragKey, LocalStorageKEYS, setLocalStorage } from '../../store/mahutiLocalStorage';
import { removeActivity, resetSelections, setOpportunity, setPaymentCountDown } from '../../store/MahutiReducer';
import './MahutiCountDown.css'
import MahutiModal from '../mahuti-modal/MahutiModal';
import { PREFIX_PATH } from '../../utils/GlobalParams';
import { isMobile } from 'react-device-detect';
import { checkTimestemp } from '../../utils/orderUtils';
import ExclamationMark from '../../svg/exclamationMark';

export default function MahutiCountDown(props) {

    const [modalOpen, setModalOpen] = useState(false);
    const [announcement, setAnnouncement] = useState('');
    const dispatch = useDispatch();
    const [seconds, setSeconds] = useState(Math.floor(props.timer % 60));
    const [mins, setMins] = useState(Math.floor(props.timer / 60));
    const [timeCalc, setTimeCalc] = useState(props.timer);
    const store = useSelector(store => store.reducer);
    const navigate = useNavigate();
    const sendToNewPurchase = () => {
        dispatch(resetSelections())
        let lpPrefix = store.lpName ? '/' + store.lpName : '';
        navigate(PREFIX_PATH + lpPrefix + '/');
    }
    
    let finalMount = useRef(true);
    useEffect(() => {
            if(finalMount.current){
                finalMount.current = false
                let counter = 0;
                timerFunc(counter)
            }
        
    }, [])

    const clearCounter = (interval) => {
        clearInterval(interval);
        setModalOpen(true)
        dispatch(removeActivity('*'))
        ClearLocalStorage()
        dispatch(setOpportunity())
    }

    useEffect(() => {
        timerFunc();
    }, [modalOpen])

    const timerFunc = (counter) => {
        let timerVal = timeCalc
        let isFirstAnnouncement = true;
        let hasAnnouncedWarning = false; // New flag

        const interval = setInterval(() => {
            counter++
            const MinsCalcInMin = Math.floor(timerVal / 60);
            setMins(MinsCalcInMin);
            const myseconds = Math.floor(timerVal % 60);
            setSeconds(myseconds);

            // Announce only once when timer starts
            if (isFirstAnnouncement && MinsCalcInMin + myseconds > 0 && !modalOpen) {
                let announcement = '';
                if (MinsCalcInMin > 0 && myseconds > 0) {
                    announcement = `הטיימר התחיל. נותרו ${MinsCalcInMin} דקות ו-${myseconds} שניות לסיום ההזמנה`;
                } else if (MinsCalcInMin > 0) {
                                        announcement = `הטיימר התחיל. נותרו ${MinsCalcInMin} דקות לסיום ההזמנה`;
                } else {
                    announcement = `הטיימר התחיל. נותרו ${myseconds} שניות לסיום ההזמנה`;
                }
                setAnnouncement(announcement);
                isFirstAnnouncement = false; 
            }
            // Warning announcements
            if (!hasAnnouncedWarning && MinsCalcInMin === 3 && myseconds === 0) {
                setAnnouncement('שימו לב, נותרו 3 דקות לסיום ההזמנה');
                hasAnnouncedWarning = true;
            }
            else if (MinsCalcInMin === 1 && myseconds === 0) {
                setAnnouncement('שימו לב, נותרה דקה אחת אחרונה לסיום ההזמנה');
            }

            if(counter === 2 && !(MinsCalcInMin === 0 && myseconds === 0)){ // check every x sec timestemp gap
                let sec = checkTimestemp(getLocalStoragKey('countDownTimestemp'), false)
                counter = 0;
                if(sec){
                    timerVal = sec
                }else{
                    clearCounter(interval)
                }
            }

            if(MinsCalcInMin === 0 && myseconds === 0) {
                setAnnouncement('זמן הרכישה הסתיים');
                clearCounter(interval)
                isFirstAnnouncement = true;
            }else{
                timerVal--
            }
        }, 1000);
    }

    // Add ref for managing focus
    const previousActiveElement = useRef(null);
    const modalRef = useRef(null);
    const closeButtonRef = useRef(null);
    const newPurchaseButtonRef = useRef(null);

    // Manage focus when modal opens/closes
    useEffect(() => {
        // אם המודל לא פתוח, לא עושים כלום
        if (!modalOpen) return;
        
        // מוצא את המודל באופן ישיר - צעד קריטי!
        const modalElement = document.querySelector('.activityDetailCard') || document.querySelector('[role="dialog"]');
        if (!modalElement) {
            console.error('לא נמצא מודל בדף');
            return;
        }
        
        // שומר את הפוקוס הנוכחי לשחזור מאוחר יותר
        previousActiveElement.current = document.activeElement;
        
        // מוצא את כל האלמנטים שניתן למקד בהם במודל
        const focusableElements = Array.from(modalElement.querySelectorAll(
            'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ));
        
        // במקרה שלא מצאנו אלמנטים, נחפש את הכפתורים
        if (focusableElements.length === 0) {
            const buttons = Array.from(modalElement.querySelectorAll('button'));
            if (buttons.length > 0) {
                focusableElements.push(...buttons);
            }
        }
        // מתמקד באופן מידי באלמנט הראשון במודל
        const firstFocusableElement = closeButtonRef.current || focusableElements[0];
        
        // עיכוב קצר לפני המיקוד - חיוני!
        // setTimeout(() => {
        //     if (newPurchaseButtonRef.current) {
        //         newPurchaseButtonRef.current.focus();
        //         console.log('Focus set to close button');
        //     }
        //     else if (firstFocusableElement) {
        //         firstFocusableElement.focus();
        //         console.log('מתמקד באלמנט:', firstFocusableElement);
        //     } else {
        //         console.error('לא נמצאו אלמנטים למיקוד במודל');
        //     }
        // }, 150);
        
        // מנהל את מלכודת המיקוד
        let currentFocusIndex = 0;
        
        // פונקציה לתפיסת מקש Tab
        const handleTabKey = (e) => {
            // יוצא אם המודל נסגר
            if (!modalOpen) return;
            
            // טיפול במקש Escape
            if (e.key === 'Escape') {
                e.preventDefault();
                setModalOpen(false);
                sendToNewPurchase();
                return;
            }
            
            // טיפול במקש Tab
            if (e.key === 'Tab') {
                // מבטל את התנהגות ברירת המחדל של Tab
                e.preventDefault();
                
                // אם אין אלמנטים שניתן למקד בהם, יוצא
                if (focusableElements.length === 0) return;
                
                // קובע את כיוון הניווט (קדימה או אחורה)
                if (e.shiftKey) {
                    // Tab + Shift (אחורה)
                    currentFocusIndex = (currentFocusIndex - 1 + focusableElements.length) % focusableElements.length;
                } else {
                    // Tab בלבד (קדימה)
                    currentFocusIndex = (currentFocusIndex + 1) % focusableElements.length;
                }

                // מתמקד באלמנט המתאים
                focusableElements[currentFocusIndex].focus();
            }
        };
        
        // פונקציה שמאכיפה את המיקוד במודל
        const forceFocusInModal = () => {
            // יוצא אם המודל נסגר
            if (!modalOpen) return;
            
            // בודק אם המיקוד הנוכחי בתוך המודל
            const activeElement = document.activeElement;
            const isFocusInModal = modalElement.contains(activeElement);
            // אם המיקוד יצא מהמודל, מחזיר אותו
            if (!isFocusInModal && focusableElements.length > 0) {
                // מתמקד באלמנט הראשון
                focusableElements[0].focus();
                currentFocusIndex = 0;
            } else if (isFocusInModal) {
                // מעדכן את האינדקס הנוכחי
                const index = focusableElements.indexOf(activeElement);
                if (index !== -1 && index !== currentFocusIndex) {
                    currentFocusIndex = index;
                }
            }
        };
        
        // מריץ את פונקציית האכיפה בתדירות גבוהה
        const intervalId = setInterval(forceFocusInModal, 50);
        
        // מוסיף מאזין מקלדת ברמת המסמך (במצב לכידה!)
        document.addEventListener('keydown', handleTabKey, true);
        
        // ניקוי משאבים
        return () => {
            clearInterval(intervalId);
            document.removeEventListener('keydown', handleTabKey, true);
            
            // החזרת המיקוד למקום הקודם כשהמודל נסגר
            if (previousActiveElement.current) {
                setTimeout(() => {
                    previousActiveElement.current.focus();
                }, 50);
            }
        };
    }, [modalOpen, sendToNewPurchase]);

    return <>
            <div 
                aria-live="polite" 
                className="sr-only" 
                role="status"
            >
                {announcement}
            </div>
            {props.showTimer && <div 
                className={"mahutiCountDown card-title " + (mins === 0 && seconds > 0 ? 'timeout_border': '')}
                role="timer"
                aria-label="זמן נותר לשמירת ההזמנה"
            >
                {mins + seconds > 0 ?
                <div className='align-items-baseline d-flex'>
                    {isMobile ? <div>נותרו</div> : <div>הזמן הנותר לשמירת ההזמנה:</div>}
                    <div className="value count_num">{`${('0' + mins).slice(-2)}:${('0' + seconds).slice(-2)}`}</div> 
                    <div className='main-color'>דקות</div>
                </div> : null}
            </div> }
            {modalOpen && <MahutiModal 
                closeModalWhenClickingBg={false} 
                setModalOpen={setModalOpen}         
                ref={modalRef}
                tabIndex="-1"
            >
                <div className="card activityDetailCard border-0 rounded-0" 
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="timeout-modal-title"
                        aria-describedby="timeout-modal-description">
                    <div className="text-start ps-2 pt-3">
                        <button 
                            onClick={() => { setModalOpen(false); sendToNewPurchase() }} 
                            className="btn btn-icon countdown_pop_close_btn "
                            ref={closeButtonRef}
                            aria-label="סגור וחזור לרכישה חדשה"
                        >
                            <i className="exit-shape icon-close close"></i>
                        </button>
                    </div>
                    <div className="modal_content text-center d-flex align-items-center justify-content-center flex-column timeout_pop">
                        <ExclamationMark aria-hidden="true"/>
                        <h4 className='mb-4 almoni_tzar_normal' id="timeout-modal-title">זמן הרכישה הסתיים</h4>  
                        <p className='mb-4 pb-2 text-mahuti' id="timeout-modal-description">סל הקניות שלך ריק.</p>  
                        <button 
                            onClick={sendToNewPurchase} 
                            className='btn btn-primary almoni_tzar_light new_purchase_btn'
                            ref={newPurchaseButtonRef}
                        >לרכישה חדשה</button>
                    </div>      
                </div>
            </MahutiModal>}
        </>
}

